import { KontentImage } from '@components/gassan-ui/Image/KontentImage'
import * as Elements from '@lib/kontent/models/Elements'
import { AnimatePresence, motion } from 'framer-motion'
import { FC } from 'react'

type Props = {
  image: Elements.AssetsElement['value'][0]
}

const ActiveSlide: FC<Props> = ({ image }) => {
  return (
    <AnimatePresence mode="wait">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ ease: 'easeOut', duration: 0.2 }}
        key={image.url}
      >
        <KontentImage className="aspect-[20/13]" alt={image.description} src={image.url} />
      </motion.div>
    </AnimatePresence>
  )
}

export default ActiveSlide
